import api from './api';

export const userService = {
  // Update user's last project
  updateLastProject: async (projectId) => {
    try {
      const response = await api.patch(`/users/me/last-project/${projectId}`);
      return response.data;
    } catch (error) {
      console.error('Error updating last project:', error);
      throw error;
    }
  },

  // Get current user's data including last_project_id
  getCurrentUser: async () => {
    try {
      const response = await api.get('/users/me');
      return response.data;
    } catch (error) {
      console.error('Error fetching current user:', error);
      throw error;
    }
  }
};
